import LeadSubmissionSettings from './LeadSubmissionSettings';

export default LeadSubmissionSettings;
